import callAPI from "../callApi";
import path from "../variables";

const Reconciliation = {
	daily: (filter?: string) =>
		callAPI("GET", `${path.base}/reconciliation/daily${filter || ""}`, "", "getting daily reconciliation"),
	history: (filter?: string) =>
		callAPI("GET", `${path.base}/reconciliation/history${filter || ""}`, "", "getting reconciliation history"),

	// Clôtures journalières (soft mode — trace scellée).
	closures: {
		list: (filter?: string) =>
			callAPI("GET", `${path.base}/reconciliation/closures${filter || ""}`, "", "listing daily closures"),
		create: (data: any) =>
			callAPI("POST", `${path.base}/reconciliation/closures`, data, "creating daily closure"),
		show: (uuid: string) =>
			callAPI("GET", `${path.base}/reconciliation/closures/${uuid}`, "", "getting daily closure"),
		approve: (uuid: string, data: any = {}) =>
			callAPI("POST", `${path.base}/reconciliation/closures/${uuid}/approve`, data, "approving daily closure"),
	},
};

export default Reconciliation;
